import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Inject, ViewChild, NgModule, Injectable } from '@angular/core';
import * as i5 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i6 from '@angular/forms';
import { FormsModule } from '@angular/forms';
import * as i4$1 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import * as i1 from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import * as i3 from '@angular/material/select';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import * as i6$1 from '@firestitch/selectbutton';
import { Color, FsSelectButtonModule } from '@firestitch/selectbutton';
import * as i3$1 from '@firestitch/badge';
import { FsBadgeModule } from '@firestitch/badge';
import * as i7 from '@firestitch/form';
import { FsFormModule } from '@firestitch/form';
import * as i2$1 from '@firestitch/autocomplete';
import { FsAutocompleteComponent, FsAutocompleteModule } from '@firestitch/autocomplete';
import { isArray, isObject, cloneDeep } from 'lodash-es';
import { Subject, BehaviorSubject, combineLatest } from 'rxjs';
import { take, takeUntil, debounceTime, map } from 'rxjs/operators';
import { isFunction } from 'rxjs/internal-compatibility';
import * as i2 from '@angular/material/form-field';
import * as i4 from '@angular/material/core';
import * as i2$2 from '@angular/cdk/overlay';

class SelectDialogComponent {
    constructor(dialogRef, data, _cdRef) {
        this.dialogRef = dialogRef;
        this.data = data;
        this._cdRef = _cdRef;
        this.options = [];
        this.selectedOption = null;
        this.label = '';
        this._destroy$ = new Subject();
    }
    ngOnInit() {
        this.label = this.data.label;
        this._initValues(this.data.values);
    }
    close(data = null) {
        this.dialogRef.close(data);
    }
    continue() {
        this.close(this.selectedOption);
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    _initValues(values) {
        if (isArray(values)) {
            this.setOptions(values);
        }
        else if (isFunction(values)) {
            this._initValues(values());
        }
        else if (isObject(values)) {
            this.data.values
                .pipe(take(1), takeUntil(this._destroy$))
                .subscribe(options => {
                this.setOptions(options);
                this._cdRef.markForCheck();
            });
        }
    }
    setOptions(options) {
        this.options = options;
        if (this.options.length) {
            this.selectedOption = this.options[0];
        }
    }
}
SelectDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: SelectDialogComponent, deps: [{ token: i1.MatDialogRef }, { token: MAT_DIALOG_DATA }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
SelectDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: SelectDialogComponent, selector: "ng-component", ngImport: i0, template: "<form (fsForm)=\"continue()\" [dirtySubmitButton]=\"false\">\n  <div mat-dialog-title> {{ label }}</div>\n  <mat-dialog-content>\n    <mat-form-field>\n      <mat-select [(ngModel)]=\"selectedOption\" name=\"selected\" required>\n        <mat-option *ngFor=\"let option of options\" [value]=\"option\">\n          {{option.name}}\n        </mat-option>\n      </mat-select>\n    </mat-form-field>\n  </mat-dialog-content>\n  <mat-dialog-actions>\n    <button type=\"submit\" color=\"primary\" mat-button>Continue</button>\n    <button type=\"button\" mat-button (click)=\"close()\">Cancel</button>\n  </mat-dialog-actions>\n</form>\n", styles: [".mat-form-field{width:100%}\n"], components: [{ type: i2.MatFormField, selector: "mat-form-field", inputs: ["color", "floatLabel", "appearance", "hideRequiredMarker", "hintLabel"], exportAs: ["matFormField"] }, { type: i3.MatSelect, selector: "mat-select", inputs: ["disabled", "disableRipple", "tabIndex"], exportAs: ["matSelect"] }, { type: i4.MatOption, selector: "mat-option", exportAs: ["matOption"] }, { type: i4$1.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }], directives: [{ type: i6.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i6.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i6.NgForm, selector: "form:not([ngNoForm]):not([formGroup]),ng-form,[ngForm]", inputs: ["ngFormOptions"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i7.FsFormDirective, selector: "[fsForm]", inputs: ["wrapperSelector", "messageSelector", "hintSelector", "labelSelector", "autocomplete", "shortcuts", "confirm", "confirmDialog", "confirmDrawer", "confirmBrowser", "confirmTabs", "dirtySubmitButton", "submit", "successDelay", "errorDelay", "tabGroup"], outputs: ["fsForm", "invalid", "valid", "submitted", "reseted", "cleared"] }, { type: i1.MatDialogTitle, selector: "[mat-dialog-title], [matDialogTitle]", inputs: ["id"], exportAs: ["matDialogTitle"] }, { type: i1.MatDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }, { type: i6.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i6.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i7.FsFormRequiredDirective, selector: "[fsFormRequired],[ngModel][required]", inputs: ["fsFormRequired", "required", "fsFormRequiredMessage"] }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i1.MatDialogActions, selector: "[mat-dialog-actions], mat-dialog-actions, [matDialogActions]" }, { type: i7.FsSubmitButtonDirective, selector: "button[type=\"submit\"]", inputs: ["name", "dirtySubmit"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: SelectDialogComponent, decorators: [{
            type: Component,
            args: [{
                    templateUrl: 'select-dialog.component.html',
                    styleUrls: ['select-dialog.component.scss'],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: i1.MatDialogRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_DIALOG_DATA]
                }] }, { type: i0.ChangeDetectorRef }]; } });

var SelectionActionType;
(function (SelectionActionType) {
    SelectionActionType["Select"] = "select";
    SelectionActionType["Action"] = "action";
    SelectionActionType["Autocomplete"] = "autocomplete";
})(SelectionActionType || (SelectionActionType = {}));

class AutocompleteDialogComponent {
    constructor(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.options = [];
        this.selected = null;
        this.label = '';
        this.placeholder = '';
        this._destroy$ = new Subject();
        this.displayWith = (data) => {
            return data.name;
        };
        this.fetch = (keyword) => {
            return this.data.values(keyword);
        };
    }
    ngOnInit() {
        this.label = this.data.label;
        if (this.data.placeholder) {
            this.placeholder = this.data.placeholder;
        }
    }
    close(data = null) {
        this.dialogRef.close(data);
    }
    continue() {
        this.close(this.selected);
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
}
AutocompleteDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: AutocompleteDialogComponent, deps: [{ token: i1.MatDialogRef }, { token: MAT_DIALOG_DATA }], target: i0.ɵɵFactoryTarget.Component });
AutocompleteDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: AutocompleteDialogComponent, selector: "ng-component", viewQueries: [{ propertyName: "autocomplete", first: true, predicate: FsAutocompleteComponent, descendants: true }], ngImport: i0, template: "<form (fsForm)=\"continue()\" [dirtySubmitButton]=\"false\">\n  <div mat-dialog-title>{{ label }}</div>\n  <mat-dialog-content>\n    <fs-autocomplete\n      [fetch]=\"fetch\"\n      [displayWith]=\"displayWith\"\n      [fetchOnFocus]=\"true\"\n      [(ngModel)]=\"selected\"\n      [required]=\"true\"\n      [placeholder]=\"placeholder\"\n      panelClass=\"fs-selection-autocomplete-panel\"\n      name=\"selected\">\n      <ng-template fsAutocompleteTemplate let-data=\"data\">\n        <div class=\"row\">\n          <fs-badge size=\"30\" [image]=\"data.image\" *ngIf=\"data.image\"></fs-badge>\n          <span>{{ data.name }}</span>\n        </div>\n      </ng-template>\n    </fs-autocomplete>\n  </mat-dialog-content>\n  <mat-dialog-actions>\n    <button type=\"submit\" color=\"primary\" mat-button>Continue</button>\n    <button type=\"button\" mat-button (click)=\"close()\">Cancel</button>\n  </mat-dialog-actions>\n</form>\n", styles: [".mat-form-field{width:100%}::ng-deep .fs-selection-autocomplete-panel .row{display:flex;align-items:center}::ng-deep .fs-selection-autocomplete-panel .row fs-badge{display:flex;margin-right:5px}\n"], components: [{ type: i2$1.FsAutocompleteComponent, selector: "fs-autocomplete", inputs: ["fetch", "placeholder", "displayWith", "fetchOnFocus", "readonly", "required", "disabled", "hint", "panelWidth", "panelClass", "showClear"], outputs: ["cleared"] }, { type: i3$1.FsBadgeComponent, selector: "fs-badge", inputs: ["color", "text", "tooltip", "size", "shape", "image", "icon", "iconSize", "iconColor", "backgroundSize"] }, { type: i4$1.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }], directives: [{ type: i6.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i6.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i6.NgForm, selector: "form:not([ngNoForm]):not([formGroup]),ng-form,[ngForm]", inputs: ["ngFormOptions"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i7.FsFormDirective, selector: "[fsForm]", inputs: ["wrapperSelector", "messageSelector", "hintSelector", "labelSelector", "autocomplete", "shortcuts", "confirm", "confirmDialog", "confirmDrawer", "confirmBrowser", "confirmTabs", "dirtySubmitButton", "submit", "successDelay", "errorDelay", "tabGroup"], outputs: ["fsForm", "invalid", "valid", "submitted", "reseted", "cleared"] }, { type: i1.MatDialogTitle, selector: "[mat-dialog-title], [matDialogTitle]", inputs: ["id"], exportAs: ["matDialogTitle"] }, { type: i1.MatDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }, { type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i6.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i7.FsFormRequiredDirective, selector: "[fsFormRequired],[ngModel][required]", inputs: ["fsFormRequired", "required", "fsFormRequiredMessage"] }, { type: i6.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { type: i2$1.FsAutocompleteTemplateDirective, selector: "[fsAutocompleteTemplate]" }, { type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1.MatDialogActions, selector: "[mat-dialog-actions], mat-dialog-actions, [matDialogActions]" }, { type: i7.FsSubmitButtonDirective, selector: "button[type=\"submit\"]", inputs: ["name", "dirtySubmit"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: AutocompleteDialogComponent, decorators: [{
            type: Component,
            args: [{
                    templateUrl: 'autocomplete-dialog.component.html',
                    styleUrls: ['autocomplete-dialog.component.scss'],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: i1.MatDialogRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_DIALOG_DATA]
                }] }]; }, propDecorators: { autocomplete: [{
                type: ViewChild,
                args: [FsAutocompleteComponent, { static: false }]
            }] } });

class SelectionDialogComponent {
    constructor(dialogRef, data, _dialog, _cdRef) {
        this.dialogRef = dialogRef;
        this.data = data;
        this._dialog = _dialog;
        this._cdRef = _cdRef;
        this.selectAllEnabled = false;
        this.allSelected = false;
        this.allCount = 0;
        this.actions = [];
        this.selectedAction = null;
        this.selectionIsEmpty = true;
        this.singleActionMode = false;
        this.noActionsAvailable = false;
        this.selectorPlaceholder = 'Actions';
        this.Color = Color;
        this._destroy$ = new Subject();
        this._selectedCount = 0;
        this._selectionRef = this.data.selectionRef;
    }
    set selectedCount(value) {
        this._selectedCount = value;
        this.selectionIsEmpty = this._selectedCount === 0;
    }
    get selectedCount() {
        return this._selectedCount;
    }
    ngOnInit() {
        this._listenConfigChanges();
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    actionClick(action, value, name) {
        this._selectionRef.action({
            value: value,
            name: name,
            all: this.allSelected,
            action: action
        });
    }
    selectAllClick() {
        this.allSelected = true;
        this.selectedCount = this.allCount;
        this._selectionRef.selectAll(this.allSelected);
    }
    cancelClick() {
        this._selectionRef.cancel();
    }
    selectAction(action) {
        this.selectedAction = action;
        if (action.type === SelectionActionType.Action) {
            this.actionClick(action, action.value, '');
        }
        else if (action.type === SelectionActionType.Select) {
            this._openSelectDialog(action);
        }
        else if (action.type === SelectionActionType.Autocomplete) {
            this._openAutocompleteDialog(action);
        }
        // Set timeout is very important feature here, because ng material value won't be updated without timeout
        setTimeout(() => {
            this.selectedAction = null;
            this._cdRef.markForCheck();
        }, 300);
    }
    _openSelectDialog(action) {
        const dialogRef = this._dialog.open(SelectDialogComponent, {
            data: action,
            width: '400px',
        });
        dialogRef.afterClosed()
            .pipe(takeUntil(this._destroy$))
            .subscribe((response) => {
            if (response) {
                this.actionClick(action, response.value, response.name);
                this._cdRef.markForCheck();
            }
        });
    }
    _openAutocompleteDialog(action) {
        const dialogRef = this._dialog.open(AutocompleteDialogComponent, {
            data: action,
            width: '400px',
        });
        dialogRef.afterClosed()
            .pipe(takeUntil(this._destroy$))
            .subscribe((response) => {
            if (response) {
                this.actionClick(action, response.value, response.name);
                this._cdRef.markForCheck();
            }
        });
    }
    _listenConfigChanges() {
        this._selectionRef.configChanges$
            .pipe(takeUntil(this._destroy$))
            .subscribe((changes) => {
            this.allCount = changes.allCount;
            this.selectedCount = changes.selectedCount;
            this.actions = changes.actions;
            this.selectAllEnabled = changes.selectAll;
            const countOfActions = this.actions.length;
            if (countOfActions === 0) {
                this.selectorPlaceholder = 'No Actions Available';
                this.noActionsAvailable = true;
                this.singleActionMode = false;
            }
            else if (countOfActions === 1) {
                this.noActionsAvailable = false;
                this.singleActionMode = true;
            }
            else {
                this.selectorPlaceholder = 'Actions';
                this.noActionsAvailable = false;
                this.singleActionMode = false;
            }
            if (changes.selectedAllStatus === this.allSelected) {
                this._checkIfAllSelected();
            }
            else {
                this.allSelected = changes.selectedAllStatus;
            }
            this._cdRef.markForCheck();
        });
    }
    _checkIfAllSelected() {
        this.allSelected = this.selectedCount === this.allCount;
    }
}
SelectionDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: SelectionDialogComponent, deps: [{ token: i1.MatDialogRef }, { token: MAT_DIALOG_DATA }, { token: i1.MatDialog }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
SelectionDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.16", type: SelectionDialogComponent, selector: "ng-component", ngImport: i0, template: "<div mat-dialog-content class=\"selection-content\">\n\n  <div class=\"selected\">\n      <span>\n        {{ selectedCount }} <ng-container *ngIf=\"allCount\">of {{ allCount }}</ng-container> Selected\n      </span>\n\n    <a \n        (click)=\"selectAllClick()\" \n        *ngIf=\"selectAllEnabled && !allSelected\" \n        class=\"select-all-link\">\n      Select All {{ allCount }}\n    </a>\n  </div>\n\n  <div class=\"actions\">\n    <ng-container *ngIf=\"!singleActionMode; else singleAction\">\n      <mat-select \n          (selectionChange)=\"selectAction($event.value)\"\n          [value]=\"selectedAction\"\n          [disabled]=\"selectionIsEmpty || noActionsAvailable\"\n          fsSelectButton\n          [color]=\"Color.Primary\"\n          [placeholder]=\"selectorPlaceholder\">\n        <mat-option *ngFor=\"let action of actions\" [value]=\"action\">\n          {{ action.label }}\n        </mat-option>\n      </mat-select>\n    </ng-container>\n\n    <ng-template #singleAction>\n      <button mat-raised-button\n              (click)=\"selectAction(actions[0])\"\n              [disabled]=\"selectionIsEmpty || noActionsAvailable\"\n              color=\"primary\"\n      > {{ actions[0].label }}\n      </button>\n    </ng-template>\n\n    <button mat-button (click)=\"cancelClick()\" class=\"action cancel-btn\">Cancel</button>\n  </div>\n\n</div>\n", styles: [".mat-select{max-width:230px!important}.mat-select.mat-select-disabled{opacity:.4}:host ::ng-deep .mat-select-value{max-width:unset}\n"], components: [{ type: i3.MatSelect, selector: "mat-select", inputs: ["disabled", "disableRipple", "tabIndex"], exportAs: ["matSelect"] }, { type: i4.MatOption, selector: "mat-option", exportAs: ["matOption"] }, { type: i4$1.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }], directives: [{ type: i1.MatDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }, { type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i6$1.FsSelectButtonDirective, selector: "[fsSelectButton]", inputs: ["color", "width", "buttonType"] }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: SelectionDialogComponent, decorators: [{
            type: Component,
            args: [{
                    templateUrl: 'selection-dialog.component.html',
                    styleUrls: [
                        './selection-dialog.component.scss',
                    ],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: i1.MatDialogRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_DIALOG_DATA]
                }] }, { type: i1.MatDialog }, { type: i0.ChangeDetectorRef }]; } });

class FsSelectionModule {
}
FsSelectionModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsSelectionModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FsSelectionModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsSelectionModule, declarations: [SelectionDialogComponent,
        SelectDialogComponent,
        AutocompleteDialogComponent], imports: [CommonModule,
        FormsModule,
        MatDialogModule,
        MatMenuModule,
        MatButtonModule,
        MatSelectModule,
        MatIconModule,
        MatCheckboxModule,
        MatTooltipModule,
        FsSelectButtonModule,
        FsAutocompleteModule,
        FsBadgeModule,
        FsFormModule] });
FsSelectionModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsSelectionModule, imports: [[
            CommonModule,
            FormsModule,
            MatDialogModule,
            MatMenuModule,
            MatButtonModule,
            MatSelectModule,
            MatIconModule,
            MatCheckboxModule,
            MatTooltipModule,
            FsSelectButtonModule,
            FsAutocompleteModule,
            FsBadgeModule,
            FsFormModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsSelectionModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        FormsModule,
                        MatDialogModule,
                        MatMenuModule,
                        MatButtonModule,
                        MatSelectModule,
                        MatIconModule,
                        MatCheckboxModule,
                        MatTooltipModule,
                        FsSelectButtonModule,
                        FsAutocompleteModule,
                        FsBadgeModule,
                        FsFormModule,
                    ],
                    entryComponents: [
                        SelectionDialogComponent,
                        SelectDialogComponent,
                        AutocompleteDialogComponent,
                    ],
                    declarations: [
                        SelectionDialogComponent,
                        SelectDialogComponent,
                        AutocompleteDialogComponent,
                    ]
                }]
        }] });

class SelectionConfig {
    constructor(config) {
        this._defaultActions = [];
        this._selectedAllStatus$ = new BehaviorSubject(false);
        this._actions$ = new BehaviorSubject([]);
        this._selectedCount$ = new BehaviorSubject(0);
        this._allCount$ = new BehaviorSubject(0);
        this._selectAll$ = new BehaviorSubject(true);
        this._destroy$ = new Subject();
        this._init(config);
    }
    get changes$() {
        return combineLatest(this._selectedCount$, this._allCount$, this._selectedAllStatus$, this._selectAll$, this._actions$).pipe(debounceTime(0), map(([selectedCount, allCount, selectedAllStatus, selectAll, actions]) => {
            return {
                selectedCount,
                allCount,
                selectedAllStatus,
                selectAll,
                actions
            };
        }));
    }
    get actions() {
        return this._actions$.getValue();
    }
    set actions(value) {
        this._actions$.next(value);
    }
    get selectedCount() {
        return this._selectedCount$.getValue();
    }
    set selectedCount(value) {
        this._selectedCount$.next(value);
    }
    get allCount() {
        return this._allCount$.getValue();
    }
    set allCount(value) {
        this._allCount$.next(value);
    }
    get selectedAllStatus() {
        return this._selectedAllStatus$.getValue();
    }
    set selectedAllStatus(value) {
        this._selectedAllStatus$.next(value);
    }
    get selectAll() {
        return this._selectAll$.getValue();
    }
    set selectAll(value) {
        this._selectAll$.next(value);
    }
    resetActions() {
        this.actions = cloneDeep(this._defaultActions);
    }
    destroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    _init(config) {
        this.selectedCount = config.selectedCount || 0;
        this.allCount = config.allCount || 0;
        this.selectAll = !!config.selectAll;
        this._defaultActions = config.actions;
        this.resetActions();
    }
}

class SelectionRef {
    constructor(config) {
        this.destroy$ = new Subject();
        this._actionSelected$ = new Subject();
        this._allSelect$ = new Subject();
        this._cancel$ = new Subject();
        this._config = new SelectionConfig(config);
    }
    /**
     * Stream with all changes in config
     */
    get configChanges$() {
        return this._config.changes$;
    }
    /**
     * Subscribe when action selected
     */
    actionSelected$() {
        return this._actionSelected$.pipe(takeUntil(this.destroy$));
    }
    /**
     * Subscribe when "Select All" is selected
     */
    allSelected$() {
        return this._allSelect$.pipe(takeUntil(this.destroy$));
    }
    /**
     * Subscribe when dialog ref was closed
     */
    cancelled$() {
        return this._cancel$.pipe(takeUntil(this.destroy$));
    }
    /**
     * Share event when action was clicked
     * @param data
     */
    action(data) {
        return this._actionSelected$.next(data);
    }
    /**
     * Share event when "Select All" was clicked
     * @param data
     */
    selectAll(data) {
        return this._allSelect$.next(data);
    }
    /**
     * Share event when dialog ref was canceled
     */
    cancel() {
        this.close();
        return this._cancel$.next();
    }
    /**
     * Close dialog ref
     */
    close() {
        this.dialogRef.close();
    }
    /**
     * Update count of selected (counter)
     * @param selectedCount
     */
    updateSelected(selectedCount) {
        this._config.selectedCount = selectedCount;
    }
    /**
     * Update total count for select
     * @param allCount
     */
    updateAllCount(allCount) {
        this._config.allCount = allCount;
    }
    /**
     * Update if all checkboxes was selected or not
     * @param status
     */
    updateSelectedAllStatus(status) {
        this._config.selectedAllStatus = status;
    }
    updateActions(actions) {
        this._config.actions = actions;
    }
    resetActions() {
        this._config.resetActions();
    }
    /**
     * Destroy ref
     */
    destroy() {
        this.destroy$.next();
        this.destroy$.complete();
        this._config.destroy();
    }
}

class SelectionDialog {
    constructor(dialog, overlay) {
        this.dialog = dialog;
        this.overlay = overlay;
        this.selectionRef = null;
    }
    open(config) {
        if (this.selectionRef) {
            return this.selectionRef;
        }
        this.selectionRef = new SelectionRef(config);
        document.body.classList.add('selection-dialog-opened');
        const dialogRef = this.dialog.open(SelectionDialogComponent, {
            width: '100%',
            panelClass: 'fs-selection-pane',
            scrollStrategy: this.overlay.scrollStrategies.reposition(),
            hasBackdrop: false,
            position: { left: '0px', bottom: '0px', right: '0px' },
            data: { selectionRef: this.selectionRef }
        });
        this.selectionRef.dialogRef = dialogRef;
        dialogRef.beforeClosed()
            .pipe(takeUntil(this.selectionRef.destroy$))
            .subscribe(result => {
            this.selectionRef.cancel();
        });
        dialogRef.afterClosed()
            .pipe(takeUntil(this.selectionRef.destroy$))
            .subscribe((result) => {
            this.selectionRef.destroy();
            this.selectionRef = null;
            document.body.classList.remove('selection-dialog-opened');
        });
        return this.selectionRef;
    }
}
SelectionDialog.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: SelectionDialog, deps: [{ token: i1.MatDialog }, { token: i2$2.Overlay }], target: i0.ɵɵFactoryTarget.Injectable });
SelectionDialog.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: SelectionDialog, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: SelectionDialog, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1.MatDialog }, { type: i2$2.Overlay }]; } });

/*
 * Public API Surface of fs-selection
 */

/**
 * Generated bundle index. Do not edit.
 */

export { FsSelectionModule, SelectionActionType, SelectionDialog, SelectionRef };
